import * as ms from 'milliseconds';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { DateString } from '@shared/types/dates';

const LOCAL_DATE_FORMAT = 'YYYY-MM-DD';

function todayDateString(): DateString {
  return moment().format(LOCAL_DATE_FORMAT);
}

export function useToday(): DateString {
  const [today, setToday] = useState<DateString>(todayDateString());

  useEffect(() => {
    // update the now marker every 5 minutes
    const h = setInterval(() => setToday(todayDateString()), ms.minutes(5));
    return () => clearInterval(h);
  }, []);

  return today;
}
